export const 
	FILTERS_AUTOLOAD			= 'FILTERS_AUTOLOAD',
	FILTERS_LOAD_PRE 			= 'FILTERS_LOAD_PRE',
	FILTERS_LOAD_REQ 			= 'FILTERS_LOAD_REQ',
	FILTERS_LOAD_SUCCESS 		= 'FILTERS_LOAD_SUCCESS',
	FILTERS_LOAD_ERROR 			= 'FILTERS_LOAD_ERROR',
	FILTERS_RESET		 		= 'FILTERS_RESET'